document.addEventListener('DOMContentLoaded', function () {
    const variantContainers = document.querySelectorAll('variant-radios');
  
   
    variantContainers.forEach(container => {
      
      const fieldsets = container.querySelectorAll('fieldset.product-form__input');
  
      fieldsets.forEach(fieldset => {
      
        const legend = fieldset.querySelector('legend.form__label');
        // Si existe y su texto es EXACTAMENTE "Color"
        if (legend && legend.textContent.trim() === 'Color') {
          // Oculta el <fieldset>
          fieldset.style.display = 'none';
        }
      });
    });
});